export default __webpack_public_path__ + "static/plus-icon-11fdbe920edda9ae2fc898f34a1d7ba4.png";